import SkeletonBlock from '@loaders/SkeletonBlock';
import { memo } from 'react';

const CARD_COUNT = 12;

export const GALLERY_GRID_CLASS =
  'grid grid-cols-2 gap-2 sm:grid-cols-3 md:gap-[9px] lg:grid-cols-4 desktop:gap-3';

export const GalleryGridSkeleton = memo(({ count = CARD_COUNT, className = '' }) => (
  <div
    className={`${GALLERY_GRID_CLASS} ${className}`.trim()}
    aria-busy="true"
    aria-label="Loading gallery"
  >
    {Array.from({ length: count }, (_, index) => (
      <div
        key={`gallery-card-skeleton-${index}`}
        className="flex flex-col gap-1.5 rounded-[9px] bg-white p-1.5 desktop:gap-2 desktop:rounded-xl desktop:p-2"
      >
        <div className="flex items-start justify-between">
          <SkeletonBlock className="icon-nav rounded" />
          <SkeletonBlock className="icon-nav rounded" />
        </div>
        <SkeletonBlock className="aspect-[255/226] w-full rounded" />
      </div>
    ))}
  </div>
));

GalleryGridSkeleton.displayName = 'GalleryGridSkeleton';

const GalleryPageSkeleton = memo(() => (
  <div
    className="flex w-full flex-col items-center bg-merchant-bg-subtle py-10 md:py-15 desktop:py-20"
    aria-busy="true"
    aria-label="Loading gallery"
  >
    <div className="flex w-full max-w-225 flex-col gap-2.5 px-4 sm:px-6 md:gap-3 desktop:max-w-280 desktop:gap-4">
      <div className="flex w-full items-center justify-between gap-3">
        <SkeletonBlock className="h-6 w-28 rounded desktop:h-8" />
        <SkeletonBlock className="h-8 w-20 rounded-full desktop:h-10 desktop:w-24" />
      </div>

      <div className="flex items-center gap-2 md:gap-[9px] desktop:gap-3">
        <SkeletonBlock className="h-8 w-14 rounded-full desktop:h-10 desktop:w-16" />
        <SkeletonBlock className="h-8 w-18 rounded-full desktop:h-10 desktop:w-22" />
        <SkeletonBlock className="h-8 w-18 rounded-full desktop:h-10 desktop:w-22" />
      </div>

      <GalleryGridSkeleton />
    </div>
  </div>
));

GalleryPageSkeleton.displayName = 'GalleryPageSkeleton';

export default GalleryPageSkeleton;
